import React from 'react';
import {
  ThreeDElementsIconFilledFilter,
  TwoDElementsIconFilledFilter,
  VideoIconFilledFilter
} from '../../modules/Icons';
import { DynamicFilterButtons } from '../shared/DynamicFilterButtons';
import { ContributorProductFiltersProps } from '../../types/components/filters/FilterTypes';
export const ProductFiltersContributor: React.FC<ContributorProductFiltersProps> = (props) => {
  const { categoryFilter, setCategoryFilter, collectionLength } = props;
  return (
    <div className="pb-8">
      <DynamicFilterButtons
        activeFilter={categoryFilter}
        setFilter={setCategoryFilter}
        buttonsConfig={[
          { category: '', label: 'All', total: collectionLength.all },
          {
            category: '2D',
            label: '2D Elements',
            IconComponent: TwoDElementsIconFilledFilter,
            total: collectionLength.twoD
          },
          {
            category: '3D',
            label: '3D Assets',
            IconComponent: ThreeDElementsIconFilledFilter,
            total: collectionLength.threeD
          },
          {
            category: 'Practice Footage Library',
            label: 'Practice Footage Library',
            IconComponent: VideoIconFilledFilter,
            total: collectionLength.practiceFootage
          }
        ]}
      />
    </div>
  );
};
